/**
 * General reducers index script file
 *
 * @package    Reducers
 * @author     Vadym Karpenko <vkarpenko@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import Immutable from 'seamless-immutable';

export const INITIAL_STATE = Immutable({
    apiHost: process.env.REACT_APP_API_HOST, // eslint-disable-line
    social: {
        orcid: {
            clientId: `${process.env.REACT_APP_ORCID_CLIENT_ID}`, // eslint-disable-line
        },
    },
});

export default function generalReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/generalReducer.js